import { ACETable } from '@/app/common/components/Table/ACETable'
import { AssociatedStudent } from '@/queries/providers/schema'
import type { QueryStatus } from '@tanstack/react-query'
import { createColumnHelper } from '@tanstack/react-table'

type AssociatedStudentsTableProps = {
  students: AssociatedStudent[]
  currentPage: number
  recordsPerPage: number
  totalRows: number
  search: string
  status: QueryStatus
  errorMessage?: string
  onSearchChange: (value: string) => void
  onPageChange: (page: number) => void
  onPerPageChange: (perPage: number) => void
  onRefresh: () => void
}

const columnHelper = createColumnHelper<AssociatedStudent>()

const columns = [
  columnHelper.accessor('id', {
    header: () => <span className="block w-24 text-center">Student ID</span>,
    cell: (info) => (
      <span className="block w-24 text-center tabular-nums">
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor('student_name', {
    header: 'Student Name',
    cell: (info) => <span>{info.getValue() || 'Not Added'}</span>,
  }),
  columnHelper.accessor('applicant_name', {
    header: 'Applicant Name (Applicant ID)',
    cell: (info) => {
      const student = info.row.original

      return (
        <span>
          {student.applicant_name
            ? `${student.applicant_name} (ID: ${student.applicant_id})`
            : `ID: ${student.applicant_id}`}
        </span>
      )
    },
  }),
]

export default function AssociatedStudentsTable({
  students,
  currentPage,
  recordsPerPage,
  totalRows,
  search,
  status,
  errorMessage,
  onSearchChange,
  onPageChange,
  onPerPageChange,
  onRefresh,
}: AssociatedStudentsTableProps) {
  return (
    <ACETable<AssociatedStudent>
      data={students}
      columns={columns}
      totalRows={totalRows}
      currentPage={currentPage}
      recordsPerPage={recordsPerPage}
      search={search}
      status={status}
      errorMessage={errorMessage}
      onSearchChange={onSearchChange}
      onPageChange={onPageChange}
      onPerPageChange={onPerPageChange}
      onRefresh={onRefresh}
      title="Associated Students"
      searchPlaceholder="Search Students"
      emptyMessage="No students are associated with this provider in the selected program."
      filter={null}
    />
  )
}
